import { LucideIconData } from 'lucide-angular';

/**
 * Iconos de lucide que `lucide-angular` todavía no trae.
 *
 * El paquete quedó en la 1.0.0 y lucide siguió sumando iconos en
 * `@lucide/angular`. Mientras no se migre a ese paquete, los que hagan falta se
 * declaran acá con los trazos del SVG oficial (lucide-static) y se registran en
 * el catálogo como cualquier otro. Al migrar, este archivo se borra y se
 * importan del paquete nuevo con el mismo nombre.
 */

/** https://lucide.dev/icons/broom-sparkles (lucide-static 1.57.0) */
export const BroomSparkles: LucideIconData = [
  ['path', { d: 'M11 2v2' }],
  ['path', { d: 'M12 3h-2' }],
  ['path', { d: 'M13.5 10.5 22 2' }],
  ['path', { d: 'M14.734 13.841a2 2 0 00-.314-2.42L12.58 9.58a2 2 0 00-2.421-.314l-7.657 4.461A1 1 0 002.3 15.3l6.403 6.403a1 1 0 001.571-.204z' }],
  ['path', { d: 'M20 15v4' }],
  ['path', { d: 'M22 17h-4' }],
  ['path', { d: 'M4 4v4' }],
  ['path', { d: 'm5 18 2-2' }],
  ['path', { d: 'M6 6H2' }],
  ['path', { d: 'm7.699 10.7 5.602 5.601' }],
];
